<template>
	<div class="alert mb-0" :class="complete ? 'alert-success' : 'alert-primary'">
		<BOverlay :show="loading">
			<template v-if="!complete">
				<h3>Provide Your ABN</h3>
				<div class="py-2">
					We need your ABN, if you have one.
					If you do not have an ABN, apply for one here: <a href="https://abr.gov.au/ABRWeb/Default.aspx?Target=AbnApply&pid=71" target="_blank">https://abr.gov.au/ABRWeb/Default.aspx?Target=AbnApply&pid=71</a>
				</div>
				<div class="my-2"></div>
				<BForm>
					<BFormRow class="form-row">
						<BCol cols="12" md="6"
							lg="6">
							<BFormGroup
								label="Enter your ABN"
								:state="getValidationState('abn')"
								:invalid-feedback="getValidationErrors('abn')">
								<BInputGroup>
									<BFormInput :model-value="abn" placeholder="00 000 000 000"
										@update:model-value="abn = $event"></BFormInput>
									<template #append>
										<BButton variant="primary" class="d-flex align-items-center gap-sm rounded-left-0"
											@click="submit">
											<BSpinner v-if="loading" small></BSpinner>
											Submit
										</BButton>
									</template>
								</BInputGroup>
							</BFormGroup>
						</BCol>
					</BFormRow>
				</BForm>
			</template>
			<template v-else>
				<h3>Thank You</h3>
				<success>
					Your ABN has been successfully updated.
				</success>
			</template>
		</BOverlay>
	</div>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import Success from '@js/components/my/ui/Success.vue';

	export default {
		components: {Success},
		props: {
			userId: {
				type: Number,
				required: false,
				default: () => null
			}
		},
		emits: ['submitted'],
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				abn: null,
				loading: false,
				complete: false,
			}
		},
		methods: {
			async submit() {
				this.loading = true;

				await this.$axios.put('/api/account/abn', {
					abn: this.abn,
				}).then(() => {
					this.$bvToast.toast('ABN updated successfully', {
						title: 'Success',
						variant: 'success',
						solid: true,
					});

					this.complete = true;
					this.$emit('submitted')
				}).catch((error) => {
					this.handleError(error);
				}).finally(() => {
					this.loading = false;
				});
			}
		}
	}
</script>
